import React, { Component } from 'react'
import '@loyal_template/recharge.css'
import PropTypes from 'prop-types'
import OperatorImg from './OperatorImg'

class SelectOperator extends Component {
  componentDidMount () {
    this.props.getMobileOperators()
  }
  getClassNameByOperator (operatorKey) {
    switch (operatorKey) {
      case 'Claro':
        return <p className='img-operadora op-claro radius' />
      case 'Nextel':
        return <p className='img-operadora op-nextel radius' />
      case 'Oi':
        return <p className='img-operadora op-oi radius' />
      case 'Tim':
        return <p className='img-operadora op-tim radius' />
      case 'Vivo':
        return <p className='img-operadora op-vivo radius' />
      case 'Brasil Telecom':
        return <p className='img-operadora op-brasil radius' />
      default:
        return ''
    }
  }

  render () {
    let operatorsOptions = []

    this.props.operators.map(item => {
      operatorsOptions.push(
        <li className='col-6 col-md-2 col-lg-2 mt-2 mt-md-1 mb-0 pr-1 pr-md-2 radius boder-color-ui-3'>
          <label htmlFor={`op-${item.mobileOperator}`}>
            <input
              name={'operadora'}
              id={`op-${item.mobileOperator}`}
              className='txt-center pb-1 pt-1'
              type='radio'
              hidden='true'
              value={item.mobileOperator}
              onChange={e => this.props.onChangeValue(e)}
              checked={item.mobileOperator === this.props.checkedValue}
            />
            <OperatorImg operatorKey={item.mobileOperator} />
          </label>
        </li>
      )
    })

    return (
      <div className='row '>
        <div className='col-md-12 col-lg-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left mt-1 px-0'>
          Selecione a operadora que deseja fazer sua recarga.
          <ul className='operadoras row'>{operatorsOptions}</ul>
        </div>
      </div>
    )
  }
}

SelectOperator.propTypes = {
  operators: PropTypes.array,
  getMobileOperators: PropTypes.func,
  checkedValue: PropTypes.string,
  onChangeValue: PropTypes.func
}

export default SelectOperator



// WEBPACK FOOTER //
// ./src/features/CellphoneRecharge/SelectOperator/SelectOperator.js